(function userControllerDefinition() {
    'use strict';

    angular.module('User')
        .controller('UserArandanosFindController', [
            '$scope', 'config', '$state', '$translate', '$filter', 'errorsExtend', 'adminUserService', 'authExtend', 'fileDownloader', 'storageService', 'messages',
            function userController($scope, config, $state, $translate, $filter, errors, adminUserService, authExtend, fileDownloader, storageService, messages) {
                $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (user) {
                            user.check = $scope.checkAll;
                        });
                    }
                };

                $scope.onBlur = function () {
                    if (!$scope.find.employeeFileNumber) {
                        $scope.find.employeeFile = null;
                    }
                };

                $scope.actionFind = function () {
                    if (!$scope.searchForm.$valid) {
                        $scope.searchForm.$setSubmitted();
                        errors.showError('VerifyContainerFormData');
                        return false;
                    }

                    storageService.setUsersFilter($scope.find);
                    $scope.items = [];
                    $scope.find.showNoData = false;
                    $scope.find.showResult = false;

                    var params = {
                        Id: $scope.find.employeeFile ? $scope.find.employeeFile.userId : null,
                        NickName: $scope.find.NickName,
                        FirstName: $scope.find.FirstName,
                        LastName: $scope.find.LastName,
                        OrganizationalUnitId: $scope.find.organizationalUnitId,
                        RedirectOptionId: $scope.find.userEnabledUI,
                        Page: $scope.data.currentPage,
                        ItemPerPage: $scope.data.itemsPerPage
                    };

                    return adminUserService.getWithParams(params).then(function (result) {
                        $scope.items = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));

                        if ($scope.items.length === 0) {
                            $scope.find.showNoData = true;
                        } else {
                            $scope.find.showResult = true;
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.enableUsers = function (optionRedirect) {
                    var params = {
                        UserIds: [],
                        RedirectOptionId: optionRedirect
                    };

                    $scope.items.forEach(function (item) {
                        if (item.check) {
                            params.UserIds.push(item.id);
                        }
                    });

                    if (params.UserIds.length === 0) {
                        errors.showWarning('UserSelectItemWarning');
                        return false;
                    }

                    messages.showConfirm('UserRedirectOptionWarning', 'ErrorConfirmTitle', 'ErrorConfirmYes', 'ErrorConfirmNo', { selectedUsers: params.UserIds.length })
                        .then(function (confirm) {
                            if (confirm) {
                                return adminUserService.setRedirectOptionBatch(params).then(function (result) {
                                    var translateKey = result === params.UserIds.length ? 'UserRedirectOptionBatchResult' : 'UserRedirectOptionBatchPartialResult';
                                    $scope.actionFind();
                                    errors.showSuccess(translateKey, 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length - result });
                                }, function (error) {
                                    if (error.data.modelState && error.data.modelState.arA001) {
                                        errors.showSuccess('UserRedirectOptionBatchPartialResult', 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length });
                                    } else {
                                        errors.showError(error);
                                    }
                                });
                            }
                        });
                };

                $scope.enableAllUsers = function (optionRedirect) {
                    messages.showConfirm('UserRedirectOptionWarning', 'ErrorConfirmTitle', 'ErrorConfirmYes', 'ErrorConfirmNo', { selectedUsers: $scope.data.totalItems })
                        .then(function (confirm) {
                            if (confirm) {
                                var params = {
                                    Id: $scope.find.employeeFile ? $scope.find.employeeFile.userId : null,
                                    NickName: $scope.find.NickName,
                                    FirstName: $scope.find.FirstName,
                                    LastName: $scope.find.LastName,
                                    OrganizationalUnitId: $scope.find.organizationalUnitId,
                                    RedirectOptionId: $scope.find.userEnabledUI,
                                    Page: $scope.data.currentPage
                                };

                                return adminUserService.getWithParams(params).then(function (result) {
                                    var params = {
                                        UserIds: [],
                                        RedirectOptionId: optionRedirect
                                    };

                                    result.value.forEach(function (item) {
                                        params.UserIds.push(item.id);
                                    });

                                    return adminUserService.setRedirectOptionBatch(params).then(function (result) {
                                        var translateKey = result === params.UserIds.length ? 'UserRedirectOptionBatchResult' : 'UserRedirectOptionBatchPartialResult';
                                        $scope.actionFind();
                                        errors.showSuccess(translateKey, 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length - result });
                                    }, function (error) {
                                        if (error.data.modelState && error.data.modelState.arA001) {
                                            errors.showSuccess('UserRedirectOptionBatchPartialResult', 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length });
                                        } else {
                                            errors.showError(error);
                                        }
                                    });
                                }, function getError(error) {
                                    errors.showError(error);
                                });
                            }
                        });
                };

                $scope.disableUsers = function () {
                    var params = {
                        UserIds: [],
                        RedirectOptionId: null
                    };

                    $scope.items.forEach(function (item) {
                        if (item.check) {
                            params.UserIds.push(item.id);
                        }
                    });

                    if (params.UserIds.length === 0) {
                        errors.showWarning('UserSelectItemWarning');
                        return false;
                    }

                    messages.showConfirm('UserCleanRedirectOptionWarning', 'ErrorConfirmTitle', 'ErrorConfirmYes', 'ErrorConfirmNo', { selectedUsers: params.UserIds.length })
                        .then(function (confirm) {
                            if (confirm) {
                                return adminUserService.setRedirectOptionBatch(params).then(function (result) {
                                    $scope.actionFind();
                                    errors.showSuccess('UserCleanRedirectOptionBatchResult', 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length - result });
                                }, function (error) {
                                    if (error.data.modelState && error.data.modelState.arA001) {
                                        errors.showSuccess('UserCleanRedirectOptionBatchResult', 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length });
                                    } else {
                                        errors.showError(error);
                                    }
                                });
                            }
                        });
                };

                $scope.disableAllUsers = function () {
                    messages.showConfirm('UserCleanRedirectOptionWarning', 'ErrorConfirmTitle', 'ErrorConfirmYes', 'ErrorConfirmNo', { selectedUsers: $scope.data.totalItems })
                        .then(function (confirm) {
                            if (confirm) {
                                var params = {
                                    Id: $scope.find.employeeFile ? $scope.find.employeeFile.userId : null,
                                    NickName: $scope.find.NickName,
                                    FirstName: $scope.find.FirstName,
                                    LastName: $scope.find.LastName,
                                    OrganizationalUnitId: $scope.find.organizationalUnitId,
                                    RedirectOptionId: $scope.find.userEnabledUI,
                                    Page: $scope.data.currentPage
                                };

                                return adminUserService.getWithParams(params).then(function (result) {
                                    var params = {
                                        UserIds: [],
                                        RedirectOptionId: null
                                    };

                                    result.value.forEach(function (item) {
                                        params.UserIds.push(item.id);
                                    });

                                    return adminUserService.setRedirectOptionBatch(params).then(function (result) {
                                        $scope.actionFind();
                                        errors.showSuccess('UserCleanRedirectOptionBatchResult', 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length - result });
                                    }, function (error) {
                                        if (error.data.modelState && error.data.modelState.arA001) {
                                            errors.showSuccess('UserCleanRedirectOptionBatchResult', 'InfoTitle', { total: params.UserIds.length, failed: params.UserIds.length });
                                        } else {
                                            errors.showError(error);
                                        }
                                    });
                                }, function getError(error) {
                                    errors.showError(error);
                                });
                            }
                        });
                };

                $scope.load = function () {
                    $scope.find = storageService.getUsersFilter();
                    $scope.find.showNoData = false;
                    $scope.find.showResult = false;
                    $scope.redirectOptions = [];
                    $scope.items = [];
                    $scope.checkAll = false;
                    $scope.emptyOu = true;
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };

                    adminUserService.getRedirectOptions().then(function (result) {
                        if (result.value && result.value.length > 0) {
                            $scope.redirectOptions = result.value;
                        }

                        $scope.actionFind();
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.load();
            }
        ]);
})();